import "../../../styles/styles.scss";
import React from "react";
import ApiService from "../../../services/ApiService";
import { store } from "../../../reducer/Store";
import { Tab, Tabs, Card, Alert } from "react-bootstrap";
import MerchandisingPlv from "./MerchandisingPlv";
// import PrestatairesTrades from "./PrestatairesTrades";
import CoordonneesAmbassadrice from "./CoordonneesAmbassadrice";
import Interlocutors from "./Interlocutors";
const Customer = () => {
  const { dispatch, state } = React.useContext(store);
  const [key, setKey] = React.useState("coordonnees");

  /**
   * Cette fonction récupère les informations d'un client à partir de son identifiant.
   * @param { Number } id - L'identifiant du client à récupérer.
   */
  const getCustomer = async (id) => {
    ApiService.request({}, "customers/" + id, "get")
      .then(function (response) {
        // console.log(response.data);
        dispatch({ type: "SET_DATACUSTOMER", payload: response.data });
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      getCustomer(state.dataSelectedClient.id);
    }
  }, [state.dataSelectedClient, key]);
  return (
    <>
      <h1>Client</h1>
      {state.dataSelectedClient && state.dataSelectedClient.id ? (
        <Tabs
          id="tabs-client"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3 bg-white"
        >
          <Tab eventKey="coordonnees" title="Coordonnées">
            <CoordonneesAmbassadrice refreshTab={key} />
          </Tab>
          <Tab eventKey="interlocuteurs" title="Interlocuteurs PF">
            <Interlocutors refreshTab={key} />
          </Tab>
          <Tab eventKey="merchandising" title="Merchandising">
            <MerchandisingPlv refreshTab={key} />
          </Tab>
          {/* NO MORE USED <Tab eventKey="prestataires" title="Prestataires">
            <PrestatairesTrades refreshTab={key} />
          </Tab> */}
        </Tabs>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner un client.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
export default Customer;
